import type { ModalActionHandler } from './modalActionTypes';
import { assignJob, getFreePopulation, MAX_MINERS } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const hireMinerAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_MINERS * settlement.buildings.ironMine.qty;
    if (settlement.jobs.miners >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'miners')) return false;
    return true;
};
